import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { RouteComponentProps } from "react-router-dom";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      padding: theme.spacing(2),
    },
    root: {
      maxWidth: 360,
      margin: `${theme.spacing(6)}px auto`,
      padding: theme.spacing(2),
    },
    title: {
      marginBottom: theme.spacing(2),
    },
    message: {
      marginTop: theme.spacing(1),
    },
    button: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(0.5),
      width: "100%",
    },
  });

interface NotFoundPageProps extends RouteComponentProps<any>, WithStyles<typeof styles> {}

export const NotFoundPageComponent = (props: NotFoundPageProps) => {
  const { location, history, classes } = props;

  const handleBackClick = () => {
    history.goBack();
  };

  return (
    <div className={classes.container}>
      <Paper className={classes.root} elevation={4}>
        <Typography className={classes.title} variant="h5">
          Not Found
        </Typography>
        <Typography className={classes.message} component="p">
          There is nothing to show at <code>{location.pathname}</code>.
        </Typography>
        <Typography className={classes.message} component="p">
          Please check your spelling and try again. Otherwise, return to the last page using the button below.
        </Typography>
        <Button variant="contained" color="primary" className={classes.button} onClick={handleBackClick}>
          Back
        </Button>
      </Paper>
    </div>
  );
};

export const NotFoundPage = withStyles(styles)(NotFoundPageComponent);
